import axios from "../request";
//检查管理员是否认证
export const checkMainAuth = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/manageSetUp/checkMainAuth",
    method: "post",
    data,
  });
};
//检查管理员认证的状态
export const checkOcrRecord = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-storage-app/ocrExamineRecord/checkOcrRecord",
    method: "post",
    data,
  });
};
//更换手机号 ocr认证
export const mainMobileOcrRecord = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-storage-app/ocrExamineRecord/mainMobileOcrRecord",
    method: "post",
    data,
  });
};
//获取应用
export const getAppByCurrentUser = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/appJurisdiction/getAppByCurrentUser",
    method: "post",
    data,
  });
};
//获取人员
export const detailAppPermission = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/appJurisdiction/detailAppPermission",
    method: "post",
    data,
  });
};
//获取全部人员
export const userMailList = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/user/userMailList",
    method: "post",
    data,
  });
};
//人员权限更改
export const userChoice = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/appJurisdiction/userChoice",
    method: "post",
    data,
  });
};

//人员审核列表
export const userExamineList = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/user/userExamineList",
    method: "post",
    data,
  });
};
//人员审核
export const userExamine = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/user/userExamine",
    method: "post",
    data,
  });
};
//人员注销
export const logOffUser = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/user/logOffUser",
    method: "post",
    data,
  });
};
//人员注销批量删除
export const batchLogOffUser = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/user/batchLogOffUser",
    method: "delete",
    data,
  });
};
//电话添加
export const mobileInvitation = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/user/mobileInvitation",
    method: "post",
    data,
  });
};
//电话添加2
export const mobileAddPersion = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/expUser/mobileInvitation",
    method: "post",
    data,
  });
};
//修改指定用户信息
export const mobileUpdateUser = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/user/updateUser",
    method: "put",
    data,
  });
};
export const getCurrentUser = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/user/getCurrentUser",
    method: "post",
    data,
  });
};
//检查公司
export const checkCompany = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/company/checkCompany",
    method: "post",
    data,
  });
};
//获取应用
export const identify = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-storage-app/ocrAuthentication/identify",
    method: "post",
    data,
  });
};
//文件上传服务
export const uploadFile = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-storage-app/obs/upload",
    method: "post",
    data,
  });
};
//审核企业
export const addOcrRecord = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-storage-app/ocrExamineRecord/addOcrRecord",
    method: "post",
    data,
  });
};
//变更管理员
export const changeMainAdmin = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/manageSetUp/changeMainAdmin",
    method: "post",
    data,
  });
};
//变更公司管理员
export const manageChangeMainAdmin = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/expManageSetUp/changeMainAdmin",
    method: "put",
    data,
  });
};
//子管理员列表
export const queryList = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/permission/queryList",
    method: "post",
    data,
  });
};
//获取detailPermission
export const detailPermission = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/permission/detailPermission",
    method: "post",
    data,
  });
};
//新增权限组
export const addPermission = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/permission/addPermission",
    method: "post",
    data,
  });
};
//修改权限组
export const updatePermission = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/permission/updatePermission",
    method: "post",
    data,
  });
};
//删除权限组
export const deletePermission = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/permission/deletePermission",
    method: "post",
    data,
  });
};
//获取应用权限列表
export const getAppPermission = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/appJurisdiction/getAppPermission",
    method: "post",
    data,
  });
};
//字典获取
export const queryDictList = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/dict/queryDictList",
    method: "post",
    data,
  });
};
//字典树获取
export const queryDictTree = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/dict/queryDictTree",
    method: "post",
    data,
  });
};
//字典树获取
export const queryDictTreeNoQB = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/dict/queryDictTreeNoQB",
    method: "post",
    data,
  });
};
//创建企业
export const createEnterprise = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/user/createEnterprise",
    method: "post",
    data
  });
};
//搜索企业
export const searchCompany = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/company/searchCompany",
    method: "post",
    data,
  });
};
//加入企业
export const applyJoinEnterprise = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/user/applyJoinEnterprise",
    method: "post",
    data
  });
};
//撤销加入企业
export const userRevokeExamine = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/user/userRevokeExamine",
    method: "post",
    data,
  });
};

//组织机构树
export const sysOrganTree = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/sysOrgan/tree",
    method: "post",
    data,
  });
};
//查询组织机下级列表
export const sysOrganChilds = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/sysOrgan/childs",
    method: "post",
    data,
  });
};
//新增组织机构
export const sysOrganAdd = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/sysOrgan/add",
    method: "post",
    data,
  });
};
//编辑组织机构
export const sysOrganEdit = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/sysOrgan/edit",
    method: "post",
    data,
  });
};
//查询组织机构详情
export const sysOrganDetail = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/sysOrgan/detail",
    method: "post",
    data,
  });
};
//批量增加成员
export const sysOrganOperationBatc = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/userOrgan/operationBatch",
    method: "post",
    data,
  });
};
//删除组织机构
export const sysOrganDelete = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/sysOrgan/delete",
    method: "post",
    data,
  });
};
//查看角色组列表
export const queryGroupRoleList = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/sysRoleGroup/queryGroupRoleList",
    method: "post",
    data,
  });
};
//新增角色组
export const addGroupRole = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/sysRoleGroup/addGroupRole",
    method: "post",
    data,
  });
};
//删除角色组
export const deletedGroupRole = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/sysRoleGroup/deletedGroupRole",
    method: "post",
    data,
  });
};
//修改角色组
export const updateGroupRole = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/sysRoleGroup/updateGroupRole",
    method: "post",
    data,
  });
};
//查看角色组
export const detailGroupRole = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/sysRoleGroup/detailGroupRole",
    method: "post",
    data,
  });
};
//查看全部角色组
export const queryAllRoleList = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/sysRole/queryAllRoleList",
    method: "post",
    data,
  });
};
//新增角色
export const addRole = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/sysRole/addRole",
    method: "post",
    data,
  });
};
//角色删除
export const deletedRole = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/sysRole/deletedRole",
    method: "post",
    data,
  });
};
//修改角色
export const updateRole = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/sysRole/updateRole",
    method: "post",
    data,
  });
};
//查看角色
export const detailRole = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/sysRole/detailRole",
    method: "post",
    data,
  });
};
//角色用菜单树
export const getFormatMenuTree = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/menu/getFormatMenuTree",
    method: "post",
    data,
  });
};
//轮播图列表
export const queryRecommendRotationList = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-information-app/recommendRotation/queryRecommendRotationList",
    method: "post",
    data,
  });
};
//资讯小视频列表
export const queryRecommendList = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-information-app/recommend/queryListApp",
    method: "post",
    data,
  });
};
//修改当前登录用户的邀请码
export const updateCurrentUserInvitationCode = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/user/updateCurrentUserInvitationCode",
    method: "post",
    data,
  });
};
//修改当前登录用户信息
export const updateCurrentUser = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/user/updateCurrentUser",
    method: "post",
    data,
  });
};
//应用获取
export const queryDefaultAppList = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/defaultApplication/queryDefaultAppList",
    method: "post",
    data,
  });
};
//应用中心(工作台)
export const appCenter = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/defaultApplication/appCenter",
    method: "post",
    data,
  });
};
//业务中心
export const businessCenter = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/defaultApplication/businessCenter",
    method: "post",
    data,
  });
};
//应用获取验证
export const checkAppClikc = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/defaultApplication/checkAppClikc",
    method: "post",
    data,
  });
};
//应用获取
export const appClikc = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/defaultApplication/appClikc",
    method: "post",
    data,
  });
};
//应用中心列表
export const appCenterList = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/defaultApplication/appCenterList",
    method: "post",
    data,
  });
};
//应用中心列表
export const expAppCenterList = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/expDefaultApplication/appCenterList",
    method: "get",
    data,
  });
};
//应用中心列表
export const myAppList = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/defaultApplication/myAppList",
    method: "post",
    data,
  });
};
//成员审核-自动审核
export const updateCompanyInfo = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/company/updateCompanyInfo",
    method: "post",
    data,
  });
};
//查询是否开启自动审核
export const companyInfo = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/company/companyInfo",
    method: "post",
    data,
  });
};
//获取我的企业列表
export const getCurrentCompanyList = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/user/getCurrentCompanyList",
    method: "post",
    data,
  });
};
//撤销解散企业
export const revokeDissolution = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/company/revokeDissolution",
    method: "post",
    data,
  });
};
// 解散企业
export const dissolutionCompany = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/company/dissolutionCompany",
    method: "post",
    data,
  });
};
// 退出登录
export const logout = (data) => {
  return axios({
    url: "/login/logout",
    method: "post",
    data,
  });
};
// 套件列表
export const queryKitList = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/defaultApplication/queryKitList",
    method: "post",
    data,
  });
};
// 钉住套件
export const checkKit = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/defaultApplication/checkKit",
    method: "post",
    data,
  });
};
// 工作区套件菜单
export const queryCheckKitList = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/defaultApplication/queryCheckKitList",
    method: "post",
    data,
  });
};
// 套件查看
export const detailKitMenu = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/defaultApplication/detailKitMenu",
    method: "post",
    data,
  });
};
// 应用权限列表
export const queryObtainAppList = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/defaultApplication/queryObtainAppList",
    method: "post",
    data,
  });
};
// 分配权限
export const assignApplicationPermissions = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/userTenantPermissionCommonUser/assignApplicationPermissions",
    method: "post",
    data,
  });
};
// 主账号分配权限
export const toConfigure = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/tenantMasterAccount/toConfigure",
    method: "post",
    data,
  });
};
// 获取已经分配权限的人
export const queryUserList = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/userTenantPermissionCommonUser/queryUserList",
    method: "post",
    data,
  });
};
// 获取主账号已经分配权限的人
export const queryMainUserList = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/tenantMasterAccount/queryUserList",
    method: "post",
    data,
  });
};
//上传视频、截图
export const uploadImage = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-storage-app/vrgv/uploadImage",
    method: "post",
    data,
  });
};
//企业基础新修改
export const updateCompany = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/company/updateCompany",
    method: "post",
    data,
  });
};
//验证是否认证中（1：认证中，2：已经变更认证通过一次，3：可发起认证）
export const checkRecord = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-storage-app/ocrExamineRecord/checkRecord",
    method: "post",
    data,
  });
};
//应用排序
export const applicationCustomSort = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/defaultApplication/applicationCustomSort",
    method: "post",
    data,
  });
};
//通讯录组织架构导入
export const importOrg = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/organImport/organization",
    method: "post",
    data,
  });
};
//通讯录组织架构编辑后重新导入
export const repeat = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/organImport/repeat",
    method: "post",
    data,
  });
};
// 查看当前通讯录用户信息
// export const queryUserInformation = (data) => {
//   return axios({
//     url: "/tvrjet-pinganfu-cust-app/user/queryUserInformation",
//     method: "post",
//     data,
//   });
// };
export const queryUserInformation = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/user",
    method: "get",
    data,
  });
};
// 热门推荐应用
export const recommendApplication = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/defaultApplication/recommendApplication/PC",
    method: "get",
    data,
  });
};
// 热门推荐应用2
export const queryRecommendAppList = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/expDefaultApplication/recommendAppList",
    method: "get",
    data,
  });
};
// 再次试用
export const reapplyTrial = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/defaultApplication/reapplyTrial",
    method: "post",
    data,
  });
};
// 应用启动次数
export const openApp = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/defaultApplication/openApp",
    method: "post",
    data,
  });
};
// 企业认证获取草稿记录
export const detailDraftRecord = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-storage-app/ocrExamineRecord/detailDraftRecord",
    method: "get",
    data,
  });
};
// 企业认证新增草稿
export const addOrUpdateDraftRecord = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-storage-app/ocrExamineRecord/addOrUpdateDraftRecord",
    method: "post",
    data,
  });
};
// 临时账号列表
export const temAccountQueryList = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/temporaryUserAccount/queryList",
    method: "get",
    data,
  });
};
// 临时账号验证账号身份状态
export const checkAccountStatus = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/temporaryUserAccount/checkAccountStatus",
    method: "get",
    data,
  });
};
// 添加临时账号
export const addTemporaryUser = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/temporaryUserAccount/addTemporaryUser",
    method: "post",
    data,
  });
};
// 修改临时账号状态
export const changeStatus = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/temporaryUserAccount/changeStatus",
    method: "put",
    data,
  });
};
// 临时账号详情
export const detailTemporaryUserAccount = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/temporaryUserAccount/detailTemporaryUserAccount",
    method: "get",
    data,
  });
};
// 临时账号删除
export const deleteTemporaryUserAccount = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/temporaryUserAccount/deleteTemporaryUserAccount",
    method: "delete",
    data,
  });
};
// 升级（实际仅仅从外部改为企业）
export const levelUp = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/temporaryUserAccount/levelUp",
    method: "put",
    data,
  });
};
// 升级（实际仅仅从外部改为企业）
export const childNodeUsers = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/sysOrgan/childNodeUsers",
    method: "get",
    data,
  });
};
// 查看更多详情（web 部门查看）
export const depDetailMore = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/sysOrgan/detailMore",
    method: "get",
    data,
  });
};
// 调整部门
export const editUsersOrgan = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/userOrgan/editUsersOrgan",
    method: "put",
    data,
  });
};
// 部门成员列表
export const organUsers = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/sysOrgan/organUsers",
    method: "get",
    data,
  });
};
// 查看更多详情（web 部门查看）
export const detailMore = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/sysOrgan/detailMore",
    method: "get",
    data,
  });
};
// 管理权限设置
export const editBatch = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/userRole/editBatch",
    method: "put",
    data,
  });
};
// 角色人员部门列表
export const roleUserOrgans = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/userRole/roleUserOrgans",
    method: "get",
    data,
  });
};
// 角色管理权限设置
export const userRole = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/userRole",
    method: "put",
    data,
  });
};
// 角色批量删除
export const batchDelete = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/userRole/batchDelete",
    method: "delete",
    data,
  });
};
// 获取地区
export const getTreeAreaPC = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/area/getTreeAreaPC",
    method: "post",
    data,
  });
};
//临时账号导入模板
export const importTemporaryUserAccount = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/temporaryUserAccount/importTemporaryUserAccount",
    method: "post",
    data,
  });
};
//临时账号重新导入
export const temRepeat = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/temporaryUserAccount/repeat",
    method: "post",
    data,
  });
};
//查询应用是否到期
export const queryAppPrompting = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/appExpiredRecord/queryAppPrompting?terminal=WEB",
    method: "get",
    data,
  });
};
